///
/// EarthBrowser
///
/// Migration v1 to v2: Remove "flight" dataset type
///
/// The flight dataset feature was removed from the codebase.
/// This migration cleans up any persisted state that still references it.
///

interface EarthbrowserStateV1 {
	visibleDatasets?: string[]
	loadingDatasets?: string[]
	sideTableContent?: string | null
}

interface StateV1 {
	earthbrowser?: EarthbrowserStateV1
}

/**
 * Migration from version 1 to 2: Remove "flight" dataset type
 *
 * Changes:
 * - Removes "flight" from visibleDatasets array
 * - Removes "flight" from loadingDatasets array
 * - Clears sideTableContent if it was set to "flight"
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV1toV2(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV1
	const oldEarthbrowser = s.earthbrowser || {}

	// Create new earthbrowser state with flight references removed
	const newEarthbrowser = {
		...oldEarthbrowser,
		// Filter out "flight" from visibleDatasets
		visibleDatasets: Array.isArray(oldEarthbrowser.visibleDatasets)
			? oldEarthbrowser.visibleDatasets.filter((d: string) => d !== "flight")
			: oldEarthbrowser.visibleDatasets,
		// Filter out "flight" from loadingDatasets
		loadingDatasets: Array.isArray(oldEarthbrowser.loadingDatasets)
			? oldEarthbrowser.loadingDatasets.filter((d: string) => d !== "flight")
			: oldEarthbrowser.loadingDatasets,
		// Clear sideTableContent if it's "flight"
		sideTableContent: oldEarthbrowser.sideTableContent === "flight"
			? null
			: oldEarthbrowser.sideTableContent
	}

	// Return completely new state object
	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
